(function(){
  /* ---------------------------------------------------------------
     PRICING - Anas's model. Read this before touching anything below.

     A plan has ONE price for ONE length AND ONE SIZE.

       - Two lengths: 13 days or 26 days. The 26-day price is always
         cheaper per day. That is the reward for committing.
       - Two sizes: Standard and Large. LARGE IS +15%, agreed 20 Aug 2026.
       - Most plans are 5 items a day: three meals, a salad and a snack.
       - The ladder is protein cost - plants, then eggs and ghee, then
         meat, then seafood. Fish is the dearest protein LUVF buys.
       - Days per week (6 or 7) decides how the days are SPREAD, not
         how many you get.

     ============================================================
     LARGE PRICES ARE WRITTEN OUT, NOT CALCULATED. Do not replace
     p.sL / p.lL with base * 1.15 at runtime.
     ============================================================
     Five of them land exactly on a half KD (270, 150, 290, 170, 310 all
     x1.15) and binary floating point does not agree with itself about
     which way those go - 270*1.15 is 310.49999999999994 in JavaScript,
     not 310.5. Compute it live and the quote says 310 while Shopify
     charges 311. The numbers below were worked out in exact decimal
     arithmetic, rounded half up, and the SAME numbers are stored on the
     Shopify variants. Quote and charge cannot drift because neither side
     does any maths. If a base price changes, recompute in decimal and
     update BOTH places.

     NO PLAN IS "A MONTH". The duration pills used to read "Half a month"
     and "A full month - better value". Anas killed both on 19 Aug.

     SIGNATURE - 2 MEALS BREAKS EVERY PRICING RULE ABOVE:
       - 25 DAYS, not 26.               p.ldays / p.lsub
       - FIVE days a week, and NOT a choice.  p.dw
       - THREE items a day.             p.items
       - One length only.               p.s = null

     ITS DELIVERY DAYS WERE SETTLED 20 Aug 2026: SUNDAY TO THURSDAY,
     Fridays and Saturdays off - the actual Kuwaiti working week. An
     earlier version of this file said Saturday to Wednesday with
     Thursdays and Fridays off, which disagreed with the homepage hero.
     Anas confirmed the Sunday-to-Thursday version is the right one. Both
     strings are valid luvf.days_per_week choices, so the mismatch failed
     silently rather than loudly - the customer simply saw one thing on
     the homepage and another in the quiz, and the kitchen cooked whatever
     they happened to click. If this ever changes again, change it in
     sections/luvf-meals-hero.liquid at the same time.

     THIS FILE AND sections/luvf-meals-hero.liquid HOLD THE SAME PLAN
     DATA TWICE. Change a plan in BOTH or they will disagree.

     ============================================================
     THE KITCHEN VOCABULARY - do not paraphrase any of these.
     ============================================================
     Flow writes these straight into CHOICE-LIST customer metafields. A
     choice list rejects anything that is not an exact character match,
     so a friendlier wording reads as the plan details silently failing
     to save - and plan_end is calculated from days per week, so that
     comes out wrong too.

     DAYS PER WEEK must be one of luvf.days_per_week's choices:
       "7 days" / "6 days - Fridays off" / "6 days - Saturdays off" /
       "5 days - Thursdays and Fridays off" /
       "5 days - Fridays and Saturdays off" / "Custom - see kitchen notes"
     A plain hyphen, not an en dash. Full weekday names.
     --------------------------------------------------------------- */
  var PLANS = {
    vegan:{ name:'Vegan', handle:'plant-based-meal-plan', s:145, sL:167, l:270, lL:311, desc:'The reset. 100% plant-based — three meals, a salad and a snack, every day.' },
    vegetarian:{ name:'Vegetarian', handle:'vegetarian-meal-plan', s:150, sL:173, l:280, lL:322, desc:'Plants plus eggs and ghee where a dish calls for them.' },
    signature:{ name:'LUVF Signature', handle:'luvf-diet-meal-plan', s:160, sL:184, l:290, lL:334, cal:'1,400–1,700 / day', calL:'1,700–2,000 / day', desc:'Three meals, a salad and a snack — the complete LUVF day.' },
    fodmap:{ name:'Low-FODMAP', handle:'low-fodmap-meal-plan', s:160, sL:184, l:290, lL:334, desc:'Built for sensitive digestion — the fermentable carbs that trigger bloating, removed.' },
    glp1:{ name:'GLP-1 Support', handle:'glp-1-support-meal-plan', s:170, sL:196, l:310, lL:357, desc:'Smaller appetite, bigger nutrition — high protein and fibre in every remaining meal.' },
    meatseafood:{ name:'Signature Meat & Seafood', handle:'signature-meat-seafood-meal-plan', s:175, sL:201, l:325, lL:374, desc:'The Signature day with seafood on the menu — beef, lamb and poultry plus fish, prawns and crab.' },
    keto:{ name:'Keto Detox', handle:'healthy-keto-meal-plan', s:180, sL:207, l:340, lL:391, desc:'A low-carb reset — no processed meat, no artificial sweeteners, no A1 dairy. A short reset, not a way to eat forever.' },
    signature2:{ name:'Signature — 2 Meals', handle:'luvf-diet-2-meals', s:null, sL:null, l:199, lL:229, ldays:25, lsub:'Five working weeks', items:3,
                 dw:'5 days - Fridays and Saturdays off', dwVal:'5',
                 desc:'Breakfast, lunch and a salad, five days a week — for people at a desk Sunday to Thursday. Fridays and Saturdays off. The same Signature menu, three items a day instead of five.' }
  };
  var GOV_CODES = {
    'Al Ahmadi':'KW-AH', 'Al Asimah':'KW-KU', 'Al Farwaniyah':'KW-FA',
    'Al Jahra':'KW-JA', 'Hawalli':'KW-HA', 'Mubarak Al-Kabeer':'KW-MU'
  };
  var BIO = [
    ['Blood Sugar & Metabolism',['Fasting Glucose','HbA1c (A1c)','Insulin','HOMA-IR']],
    ['Heart & Cholesterol',['Total Cholesterol','LDL ("bad" cholesterol)','HDL ("good" cholesterol)','Triglycerides','ApoB']],
    ['Inflammation',['CRP / hs-CRP','Homocysteine']],
    ['Vitamins & Minerals',['Vitamin D','Vitamin B12','Folate','Iron','Ferritin','Omega-3','Magnesium']],
    ['Hormones',['Cortisol','Thyroid (TSH)','Free T3','DHEA-S']]
  ];
  var PROTEINS = {
    'RED MEAT': ['Beef','Lamb'],
    'POULTRY': ['Chicken','Duck','Turkey'],
    'SEAFOOD': ['Hamour','Balool','Zubaidi','Seabass','Cod','Salmon','Tuna','Crab','Shrimp / Prawns'],
    'VEGETARIAN': ['Black bean','Chickpea','Edamame','Eggs','Lentil','Nutritional Yeast','Quinoa','Tempeh','Tofu']
  };
  var STYLE_SECTIONS = {
    'Meat & Seafood': ['RED MEAT','POULTRY','SEAFOOD'],
    'Seafood & Vegetarian': ['VEGETARIAN','SEAFOOD'],
    'Meat & Vegetarian': ['RED MEAT','VEGETARIAN','POULTRY'],
    'Vegetarian': ['VEGETARIAN'],
    'Vegan': ['VEGETARIAN']
  };
  var CUISINES = ['Kuwaiti','Middle Eastern','Persian','African','American','Chinese','French','Greek','Indian','Italian','Japanese','Korean','Latin American','Mexican','Southeast Asian','Thai'];

  /* ---------- FOODS TO AVOID ----------
     THE TWO LISTS BELOW ARE THE CHOICE LISTS ON luvf.avoid_allergens AND
     luvf.avoid_exclusions, CHARACTER FOR CHARACTER, and they are also the
     choice lists on the luvf_ingredient metaobject. Do not tidy the
     singular/plural - "Egg" and "Peanut" are singular, "Tree nuts" and
     "Mushrooms" are plural, because that is how the metafields were
     defined. A near-miss does not warn; the field just stays empty and
     the kitchen never learns about the allergy. To add an option, add it
     to the metafield definitions FIRST, then copy it here.

     WHY TWO LISTS. An allergen is a safety stop - that dish never goes
     near that customer. A preference is a swap - same meal, different
     ingredient. Collapsing them is how a dislike gets treated as an
     allergy (and the kitchen stops trusting the list) or an allergy gets
     treated as a dislike (and someone ends up in hospital).

     GLUTEN, WHEAT, refined sugar, seed oils, pork and alcohol are on no
     list here even though Gluten and Wheat are valid metafield choices.
     Every plan already excludes them for everyone, and a chip for
     something we never cook with reads as though we might. Dairy IS here,
     because a dairy ALLERGY is not the Dairy? preference question above.

     ============================================================
     THREE FREE, THEN CHARGED, CAPPED AT TEN.
     Anas, 20 Aug 2026 late evening, revised again the same night.
     ============================================================
     AVOID_FREE = 3. The count is ACROSS BOTH CHIP LISTS AND THE TYPE-IN
     BOX together - three in total, not three of each. Each avoid past
     the third is CHARGED: 5 KD on a 26-day plan, 3 KD on a 13-day plan,
     per avoid, once for the whole plan, never per week. It is shown as
     an orange running line under the chips the moment it goes over,
     folded into the quoted price on the PROGRAM and REVIEW steps, and
     charged at checkout via the hidden product 'extra-food-to-avoid'
     (variants '26-day plan' 5 KD / '13-day plan' 3 KD - THE PRICE LIVES
     ON THOSE VARIANTS, never here; the quiz only sends a quantity).

     (SUPERSEDED 27 Aug 2026 - see the block below. Kept as history.)
     AVOID_MAX = 10 is new. [stated] Anas: "or maybe it should lock after
     a certain number as thats just stupid?" - and he is right that
     uncapped is not a real offer: twenty avoids is 100 KD on a 290 KD
     plan, and at that point the kitchen cannot cook the plan at all.
     Selecting stops at ten; UNSELECTING always works, so nobody can get
     stuck.

     I ARGUED FOR EXEMPTING ALLERGIES FROM BOTH THE CHARGE AND THE CAP
     and Anas decided against it - allergies are charged and counted like
     preferences. Recorded because it is a live risk, not to relitigate:
     a coeliac tapping Tree nuts / Peanut / Sesame / Dairy / Egg is shown
     a bill for declaring an allergy, and at ten they are stopped. The
     cap message therefore MUST point at the kitchen's allergy call,
     which happens before anything is cooked - that is the safety route
     and it is the one thing that keeps the cap from being dangerous.
     Do not remove that sentence.

     Note this is NOT the dead "call us and we will arrange it" pricing
     wording, which Anas killed - that was about arranging the CHARGE.
     This is about confirming an ALLERGY, which his own brief keeps.

     sections/luvf-quiz.liquid explains none of this any more - it holds
     only the allergy reassurance line. updateAvoidLimits() below is the
     single source of truth for the rule, and FAQ f2 on the homepage and
     the meal-plans page must tell the same story. Keep them in step.

     ============================================================
     27 Aug 2026 - THE CAP IS GONE AND SIX CHIPS OPEN A PANEL.
     Anas, 26-27 Aug. Design: the "LUVF Avoids Panel" artifact.
     ============================================================
     [stated] "they should be able to add as much as they want and the
     price can keep adding after the first 3". AVOID_MAX is removed;
     nothing greys out; the counter keeps charging past three however
     long the list gets, and its charged state now also says that
     variety drops. Allergens stay counted and charged like preferences -
     settled twice, do not re-open.

     SIX EXISTING CHIPS ARE NOT AVOIDS. Chicken, Red meat, Onion, Garlic,
     Nightshades and Legumes stay in the PREFERENCES list exactly where
     they were, but tapping one (or typing its word, or a synonym, into
     the box) opens a panel under the counter instead of counting:
       - Chicken / Red meat: a main ingredient cannot come out of a meat
         plan (order #7377 was a chicken plan sold chicken-free). The
         panel offers Seafood & Vegetarian and Vegetarian with prices and
         the way out is "Keep my plan - untap chicken". Switching sets
         A.style and clears A.planOverride.
       - Onion / Garlic: they go in first, into the stock, and cannot be
         strained back out. The panel offers Low-FODMAP (A.planOverride).
         A Vegetarian or Vegan is told Low-FODMAP is not for them and it
         goes to the kitchen call, counted as nothing.
       - Nightshades / Legumes: a family, not an ingredient. The panel
         opens the members and EACH member ticked is one priced avoid,
         stored in A.avoids under its own name so the kitchen can cook
         from it. Chilli / Soy / Peanut / Lupin inside a family ARE the
         chips of the same name - one thing never counts twice.
       - A set that cannot be cooked (Vegetarian with Egg + every protein
         legume out, or Vegan with every protein legume out) opens on its
         own and offers what to keep.
     The panel ASKS NOTHING - Anas rejected a question step and a new chip
     group ("you are giving them ideas"). Continue is held while a panel
     is open (valid() step 4). The closed one-line summary ships as the
     hidden order property _Panel so the kitchen sees the same sentence.
     Every panel sentence is a theme setting in sections/luvf-quiz.liquid
     (ap_*), handed to this file through the #lqPanelTxt JSON tag, with
     the English below as the fallback - so Translate & Adapt can reach
     them. The six chip VALUES never change. */
  var AVOID_FREE = 3;
  var AVOID_FEE_LONG = 5, AVOID_FEE_SHORT = 3;
  var AVOID_FEE_HANDLE = 'extra-food-to-avoid';
  var AVOID_CHIPS = [
    { key:'allergens', head:'ALLERGIES',
      items:['Dairy','Egg','Fish','Shellfish','Tree nuts','Peanut','Sesame','Soy','Mustard','Celery','Lupin','Sulphites'] },
    { key:'prefs', head:'PREFERENCES',
      items:['Coconut','Nightshades','Onion','Garlic','Corn','Honey','Mushrooms','Legumes','Citrus','Chilli','Coriander','Avocado','Caffeine','Yeast','Red meat','Chicken'] }
  ];

  /* the six chips that open the panel, and what each one opens */
  var AVOID_TRIGGER = { 'Chicken':'protein', 'Red meat':'protein', 'Onion':'allium', 'Garlic':'allium', 'Nightshades':'family', 'Legumes':'family' };
  /* family members: [value written to the order, hint shown beside it] */
  var AVOID_FAMILY = {
    'Nightshades': [['Tomato',''],['Potato',''],['Aubergine','eggplant'],['Bell pepper','capsicum'],['Chilli',''],['Paprika & cayenne','']],
    'Legumes': [['Chickpea',''],['Lentil',''],['Black bean',''],['Kidney bean',''],['Peas',''],['Green beans',''],['Soy','tofu, tempeh, miso, soy sauce'],['Peanut',''],['Lupin','']]
  };
  var PROTEIN_LEGUMES = ['Chickpea','Lentil','Black bean','Kidney bean','Soy'];
  /* typed words that mean a chip or a family member; keys lower-case.
     28 Aug 2026: Arabic entries added - the Arabic site shows Arabic chips,
     so Arabic typing must route through the same rules. Values stay the
     canonical ENGLISH names the kitchen vocabulary requires. */
  var AVOID_SYN = {
    'بصل':'Onion', 'البصل':'Onion', 'بصل أخضر':'Onion', 'البصل الأخضر':'Onion', 'كراث':'Onion',
    'ثوم':'Garlic', 'الثوم':'Garlic',
    'باذنجانيات':'Nightshades', 'الباذنجانيات':'Nightshades',
    'بقوليات':'Legumes', 'البقوليات':'Legumes', 'بقول':'Legumes', 'فاصولياء':'Legumes', 'فاصوليا':'Legumes', 'الفاصولياء':'Legumes', 'الفاصوليا':'Legumes',
    'دجاج':'Chicken', 'الدجاج':'Chicken', 'فراخ':'Chicken', 'دواجن':'Chicken', 'الدواجن':'Chicken',
    'لحم':'Red meat', 'اللحم':'Red meat', 'لحوم':'Red meat', 'اللحوم':'Red meat', 'لحم أحمر':'Red meat', 'اللحم الأحمر':'Red meat', 'لحم بقر':'Red meat', 'لحم غنم':'Red meat', 'بقر':'Red meat', 'غنم':'Red meat',
    'طماطم':'Tomato', 'الطماطم':'Tomato', 'بندورة':'Tomato',
    'بطاطس':'Potato', 'البطاطس':'Potato', 'بطاطا':'Potato', 'البطاطا':'Potato',
    'باذنجان':'Aubergine', 'الباذنجان':'Aubergine',
    'فلفل رومي':'Bell pepper', 'الفلفل الرومي':'Bell pepper', 'فلفل':'Bell pepper', 'الفلفل':'Bell pepper',
    'فلفل حار':'Chilli', 'الفلفل الحار':'Chilli', 'شطة':'Chilli',
    'بابريكا':'Paprika & cayenne',
    'حمص':'Chickpea', 'الحمص':'Chickpea',
    'عدس':'Lentil', 'العدس':'Lentil',
    'فاصولياء سوداء':'Black bean', 'فاصوليا سوداء':'Black bean',
    'فاصولياء حمراء':'Kidney bean', 'فاصوليا حمراء':'Kidney bean',
    'بازلاء':'Peas', 'البازلاء':'Peas',
    'فاصولياء خضراء':'Green beans', 'فاصوليا خضراء':'Green beans',
    'صويا':'Soy', 'الصويا':'Soy', 'توفو':'Soy', 'فول الصويا':'Soy',
    'فول سوداني':'Peanut', 'الفول السوداني':'Peanut',
    'ترمس':'Lupin', 'الترمس':'Lupin',
    'ألبان':'Dairy', 'الألبان':'Dairy', 'حليب':'Dairy', 'الحليب':'Dairy', 'جبن':'Dairy', 'الجبن':'Dairy', 'لبن':'Dairy',
    'بيض':'Egg', 'البيض':'Egg', 'بيضة':'Egg',
    'سمك':'Fish', 'السمك':'Fish', 'أسماك':'Fish', 'الأسماك':'Fish',
    'قشريات':'Shellfish', 'القشريات':'Shellfish', 'روبيان':'Shellfish', 'الروبيان':'Shellfish', 'جمبري':'Shellfish', 'الجمبري':'Shellfish', 'محار':'Shellfish',
    'مكسرات':'Tree nuts', 'المكسرات':'Tree nuts', 'مكسرات شجرية':'Tree nuts',
    'سمسم':'Sesame', 'السمسم':'Sesame', 'طحينة':'Sesame', 'الطحينة':'Sesame',
    'خردل':'Mustard', 'الخردل':'Mustard',
    'كرفس':'Celery', 'الكرفس':'Celery',
    'كبريتيت':'Sulphites',
    'جوز الهند':'Coconut', 'جوز هند':'Coconut',
    'ذرة':'Corn', 'الذرة':'Corn',
    'عسل':'Honey', 'العسل':'Honey',
    'فطر':'Mushrooms', 'الفطر':'Mushrooms', 'مشروم':'Mushrooms',
    'حمضيات':'Citrus', 'الحمضيات':'Citrus', 'ليمون':'Citrus', 'الليمون':'Citrus', 'برتقال':'Citrus',
    'كزبرة':'Coriander', 'الكزبرة':'Coriander',
    'أفوكادو':'Avocado', 'الأفوكادو':'Avocado', 'افوكادو':'Avocado',
    'كافيين':'Caffeine', 'الكافيين':'Caffeine', 'قهوة':'Caffeine', 'القهوة':'Caffeine',
    'خميرة':'Yeast', 'الخميرة':'Yeast', 'eggplant':'Aubergine', 'capsicum':'Bell pepper', 'pepper':'Bell pepper', 'peppers':'Bell pepper', 'bell peppers':'Bell pepper', 'tomatoes':'Tomato', 'potatoes':'Potato',
    'pulses':'Legumes', 'beans':'Legumes', 'nightshade':'Nightshades', 'night shades':'Nightshades', 'night shade':'Nightshades',
    'spring onion':'Onion', 'spring onions':'Onion', 'shallot':'Onion', 'shallots':'Onion', 'onions':'Onion', 'garlics':'Garlic',
    'poultry':'Chicken', 'beef':'Red meat', 'lamb':'Red meat', 'meat':'Red meat', 'redmeat':'Red meat',
    'nuts':'Tree nuts', 'eggs':'Egg', 'prawns':'Shellfish', 'prawn':'Shellfish', 'shrimp':'Shellfish', 'mushroom':'Mushrooms', 'chillies':'Chilli', 'chili':'Chilli', 'chilies':'Chilli' };
  /* every panel sentence, English fallback; sections/luvf-quiz.liquid overrides via #lqPanelTxt */
  var PANEL_TXT = {
    eb_plan:'This changes your plan', eb_fam:'Which ones do you mean?', eb_imp:'We cannot cook this', why:'Why', change:'Change', hold:'Choose to continue',
    p_lead_chicken:'Chicken is a main ingredient on {plan}, not a garnish — we cannot take it out of this plan. These plans are built without it, and there is no charge for the change.',
    p_lead_red:'Beef and lamb are main ingredients on {plan}, not a garnish — we cannot take them out of this plan. These plans are built without them, and there is no charge for the change.',
    p_why:'Our meat plans are built around chicken, beef and lamb from the stock up. Taking one out changes most of the week, so we move you to a plan that already eats the way you do instead of rebuilding dishes.',
    p_already:'{style} has no {x} on the menu, so there is nothing to avoid. We took the chip off.',
    p_fixed:'You are on {plan} because of your goal, and {x} is one of its main proteins, so we cannot take it out. Untap {x}, or tell the kitchen which proteins you prefer when they call — this is not counted as an avoid.',
    opt_sv:'Fish carries the protein — no land meat', opt_veg:'Plants plus eggs and ghee — no meat, no fish',
    price_same:'{price} KD for {days} days — same as now', price_more:'{price} KD for {days} days — {diff} KD more than {from}, fish is our dearest protein', price_less:'{price} KD for {days} days — {diff} KD less than {from}',
    switch_to:'Switch to {plan}', keep:'Keep my plan — untap {x}', p_closed:'No {x} → {plan}',
    a_lead:'{x} goes in first — into the stock and the base of almost every dish — so it cannot be taken out of a finished meal. Our Low-FODMAP plan is built without onion and garlic from the start, at no extra charge.',
    a_why:'The part of onion and garlic that upsets a sensitive gut dissolves into the cooking water in the first minutes. Straining them out afterwards changes nothing. The only honest way to serve a dish without them is never to put them in, which is how the Low-FODMAP kitchen works.',
    a_opt:'Built for sensitive digestion — no onion, no garlic, none of the fermentable carbs behind bloating',
    a_price_same:'{price} KD for {days} days — same as {from}', a_price_more:'{price} KD for {days} days — {diff} KD more than {from}', a_price_less:'{price} KD for {days} days — {diff} KD less than {from}',
    a_veg:'Low-FODMAP is not a vegetarian plan, so it is not the answer for you. We will go lighter on {x}, and the kitchen will confirm what is possible when they call. This is not counted as an avoid.',
    a_closed:'No {x} → Low-FODMAP', a_closed_light:'Lighter on {x} → kitchen call',
    f_lead_night:'Nightshades is a family, not one ingredient. Tap the ones you mean — most people mean tomato and pepper, not potato. Each one counts as one avoid.',
    f_lead_leg:'Legumes is a family, not one ingredient. Tap the ones you mean. Each one counts as one avoid. Soy, peanut and lupin are also in the allergy list — one tap counts once.',
    f_why:'Each member is a different ingredient to the kitchen. Taking out tomato is easy; taking out every nightshade rebuilds the week. Counting them one by one keeps the price honest and the list accurate.',
    f_hidden_night:'Also hidden in: ketchup, salsa, most curry powders, chipotle, potato starch.', f_hidden_leg:'Also hidden in: hummus, falafel, soy sauce, miso, peanut oil.',
    f_all:'The whole family', f_none:'Clear', f_done:'Done', f_count_one:'1 counted as an avoid', f_count_many:'{n} counted as avoids', f_closed:'{family} — {n} out: {list}',
    i_lead:'A vegetarian week without eggs and without legumes has almost no protein left, and we would rather say so than take the order. Keep one of these and we can cook for you.',
    i_why:'Eggs, lentils, chickpeas, beans and soy are where the protein comes from on a plant-based plan. With all of them out, a day falls well below the protein we promise.',
    i_eggs:'Keep eggs', i_soy:'Keep soy — tofu, tempeh', i_beans:'Keep chickpea & lentil', i_fish:'I eat fish — switch to Seafood & Vegetarian',
    i_eggs_r:'Keeping eggs. The legumes stay out, nothing extra is charged for this change.',
    i_soy_r:'Keeping soy — tofu and tempeh carry the protein. The other legumes stay out, nothing extra is charged.',
    i_beans_r:'Keeping chickpea and lentil. Eggs and the other legumes stay out, nothing extra is charged.',
    i_fish_r:'Seafood & Vegetarian — fish carries the protein, eggs and legumes stay out.',
    c_left:'{n} of 3 free avoids left.', c_used:'3 of 3 free avoids used. Anything more adds 5 KD each on a 26-day plan, 3 KD on a 13-day plan.',
    c_extra_one:'+{fee} KD added to your total — 1 extra avoid at {each} KD. Three are included; untap anything to remove it. The more you leave out, the less variety we can give you across the week.',
    c_extra_many:'+{fee} KD added to your total — {n} extra avoids at {each} KD each. Three are included; untap anything to remove it. The more you leave out, the less variety we can give you across the week.'
  };
  var P = null;   /* the open panel: { type, x, closed, removed, fromStyle, why, summary, plain } */

  var A = { drivers:[], cuisines:[], proteins:[], avoids:[], avoidSel:{ allergens:[], prefs:[] }, flags:{}, ack:false };
  var steps, rail, cur = 0;

  function $(s,c){ return (c||document).querySelector(s); }
  function $$(s,c){ return Array.prototype.slice.call((c||document).querySelectorAll(s)); }
  function whole(n){ return String(Math.round(n)); }
  function d1(n){ return (Math.round(n*10)/10).toFixed(1).replace(/\.0$/,''); }
  function allAvoids(){
    return A.avoidSel.allergens.concat(A.avoidSel.prefs).concat(A.avoids);
  }
  function avoidCount(){ return allAvoids().length; }
  function txt(k, vars){
    var str = PANEL_TXT[k] || '';
    if(vars) Object.keys(vars).forEach(function(v){ str = str.split('{' + v + '}').join(vars[v]); });
    return str;
  }
  function esc(str){ return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }
  function loadPanelTxt(){
    var el = $('#lqPanelTxt');
    if(!el) return;
    try{
      var o = JSON.parse(el.textContent || '{}');
      Object.keys(o).forEach(function(k){ if(typeof o[k] === 'string' && o[k].trim()) PANEL_TXT[k] = o[k]; });
    }catch(e){}
  }
  function avoidExtra(){ return Math.max(0, avoidCount() - AVOID_FREE); }
  function avoidFeeEach(){ return price().long ? AVOID_FEE_LONG : AVOID_FEE_SHORT; }
  function avoidFee(){ return avoidExtra() * avoidFeeEach(); }

  /* ---------- selection widgets ---------- */
  function wireGroup(g){
    if(g.hasAttribute('data-wired')) return;
    g.setAttribute('data-wired','1');
    if(g.hasAttribute('data-single')){
      $$('button',g).forEach(function(b){
        b.addEventListener('click', function(){
          if(b.disabled || b.style.display === 'none') return;
          $$('button',g).forEach(function(x){ x.classList.remove('on'); });
          b.classList.add('on');
          A[g.getAttribute('data-a')] = b.getAttribute('data-v');
          onAnswer(g.getAttribute('data-a'));
          refresh();
        });
      });
    } else if(g.hasAttribute('data-multi')){
      var max = parseInt(g.getAttribute('data-multi'),10), key = g.getAttribute('data-a');
      if(!A[key]) A[key] = [];
      $$('button',g).forEach(function(b){
        b.addEventListener('click', function(){
          var v = b.getAttribute('data-v'), arr = A[key];
          var i = arr.indexOf(v);
          if(i>-1){ arr.splice(i,1); b.classList.remove('on'); }
          else if(arr.length < max){ arr.push(v); b.classList.add('on'); }
          refresh();
        });
      });
    }
  }
  function wire(){
    $$('[data-single],[data-multi]').forEach(wireGroup);
    $$('input[data-a],select[data-a],textarea[data-a]').forEach(function(el){
      var sync = function(){ A[el.getAttribute('data-a')] = el.value.trim(); refresh(); };
      el.addEventListener('input', sync);
      el.addEventListener('change', sync);
    });
  }
  function onAnswer(key){
    if(key === 'style') buildProteins();
    if(key === 'length' || key === 'planOverride' || key === 'sizeOverride'){ renderProgram(); updateAvoidLimits(); }
    if(key === 'labGate'){
      var deep = A.labGate === 'I know what needs work';
      $('#lqBioWrap').hidden = !deep;
      $('#lqGateView').hidden = deep;
      if(deep) window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  /* ---------- proteins ---------- */
  function buildProteins(){
    var host = $('#lqProteins'); host.innerHTML = '';
    var sections = STYLE_SECTIONS[A.style] || ['RED MEAT','POULTRY','SEAFOOD'];
    A.proteins = [];
    sections.forEach(function(sec){
      var h = document.createElement('p'); h.className = 'lq-h5'; h.textContent = sec; host.appendChild(h);
      var grid = document.createElement('div'); grid.className = 'lq-checks';
      PROTEINS[sec].forEach(function(pv){
        var b = document.createElement('button'); b.type='button'; b.className='lq-check';
        b.innerHTML = '<i></i><span>'+pv+'</span>';
        b.addEventListener('click', function(){
          var i = A.proteins.indexOf(pv);
          if(i>-1){ A.proteins.splice(i,1); b.classList.remove('on'); }
          else { A.proteins.push(pv); b.classList.add('on'); }
          refresh();
        });
        grid.appendChild(b);
      });
      host.appendChild(grid);
    });
  }

  /* ---------- cuisines ---------- */
  function buildCuisines(){
    var host = $('#lqCuisines');
    CUISINES.forEach(function(cv){
      var b = document.createElement('button'); b.type='button'; b.className='lq-check';
      b.setAttribute('data-v', cv);
      b.innerHTML = '<i></i><span>'+cv+'</span>';
      host.appendChild(b);
    });
    wireGroup(host);
  }

  /* ---------- foods to avoid ----------
     No ceiling any more (27 Aug 2026). REMOVING is always allowed. A typed
     word goes through the same rules as a tapped chip: a chip name or a
     synonym lights that chip, one of the six trigger words opens the
     panel, a family member (or its synonym) is added under its own name
     and opens its family. See the block comment above. */
  function familyOf(member){
    var f = null;
    Object.keys(AVOID_FAMILY).forEach(function(k){ AVOID_FAMILY[k].forEach(function(m){ if(m[0] === member) f = k; }); });
    return f;
  }
  /* a typed SENTENCE goes through the same rules as a typed word. Order
     #17387 (27 Aug 2026): "no nightshades (severe inflammation)" matched
     nothing, so the whole phrase became one 3 KD avoid and the kitchen
     never learned which nightshades. Longest name wins, so "spring onion"
     beats "onion" and "red meat" beats "meat"; boundaries stop "corn"
     matching inside "popcorn". */
  function phraseMatch(v){
    var names = [];
    Object.keys(AVOID_TRIGGER).forEach(function(k){ names.push([k.toLowerCase(), k]); });
    AVOID_CHIPS.forEach(function(g){ g.items.forEach(function(it){ names.push([it.toLowerCase(), it]); }); });
    Object.keys(AVOID_FAMILY).forEach(function(f){ AVOID_FAMILY[f].forEach(function(m){
      names.push([m[0].toLowerCase(), m[0]]);
      if(m[1]) m[1].split(',').forEach(function(h){ h = h.trim().toLowerCase(); if(h) names.push([h, m[0]]); });
    }); });
    Object.keys(AVOID_SYN).forEach(function(k){ names.push([k, AVOID_SYN[k]]); });
    names.sort(function(a,b){ return b[0].length - a[0].length; });
    for(var i = 0; i < names.length; i++){
      var idx = v.indexOf(names[i][0]);
      if(idx === -1) continue;
      var before = idx === 0 ? ' ' : v.charAt(idx - 1);
      var after = (idx + names[i][0].length) >= v.length ? ' ' : v.charAt(idx + names[i][0].length);
      if(/[a-z0-9؀-ۿ]/.test(before) || /[a-z0-9؀-ۿ]/.test(after)) continue;
      return names[i][1];
    }
    return null;
  }
  function addAvoid(v){
    v = (v || '').trim().replace(/[,;]+$/,'').trim().toLowerCase();
    if(!v) return;
    var canon = null;
    AVOID_CHIPS.forEach(function(grp){ grp.items.forEach(function(it){ if(it.toLowerCase() === v) canon = it; }); });
    if(!canon) Object.keys(AVOID_FAMILY).forEach(function(k){ AVOID_FAMILY[k].forEach(function(m){ if(m[0].toLowerCase() === v || (m[1] && m[1].toLowerCase() === v)) canon = m[0]; }); });
    if(!canon && AVOID_SYN[v]) canon = AVOID_SYN[v];
    if(!canon) canon = phraseMatch(v);
    if(canon && AVOID_TRIGGER[canon]){ openPanel(canon); return; }
    if(canon){
      var hit = null;
      AVOID_CHIPS.forEach(function(grp){ if(grp.items.indexOf(canon) > -1) hit = grp.key; });
      if(hit){
        if(A.avoidSel[hit].indexOf(canon) === -1) A.avoidSel[hit].push(canon);
      } else {
        if(A.avoids.indexOf(canon) === -1) A.avoids.push(canon);
        var fam = familyOf(canon);
        if(fam){ P = { type:'family', x:fam, closed:false, scroll:true }; }
      }
    } else {
      if(A.avoids.indexOf(v) > -1) return;
      A.avoids.push(v);
    }
    drawAvoids(); refresh();
  }
  function removeAvoid(v){
    var i = A.avoids.indexOf(v);
    if(i > -1){ A.avoids.splice(i,1); drawAvoids(); refresh(); }
  }
  function toggleChip(key, item){
    if(AVOID_TRIGGER[item]){
      if(P && P.x === item && !P.closed){ P = null; drawAvoids(); refresh(); return; }
      if(AVOID_TRIGGER[item] === 'family' && familyPicked(item).length){
        /* a lit family chip untaps its members, chips included */
        if(P && P.x === item) P = null;
        familyPicked(item).forEach(toggleMember);
        return;
      }
      openPanel(item); return;
    }
    var arr = A.avoidSel[key], i = arr.indexOf(item);
    if(i > -1){ arr.splice(i,1); }
    else { arr.push(item); }
    drawAvoids(); refresh();
  }
  function hasAvoid(name){
    return A.avoids.indexOf(name) > -1 || A.avoidSel.allergens.indexOf(name) > -1 || A.avoidSel.prefs.indexOf(name) > -1;
  }
  function familyPicked(fam){
    return AVOID_FAMILY[fam].filter(function(m){ return hasAvoid(m[0]); }).map(function(m){ return m[0]; });
  }
  function toggleMember(name){
    /* a member that is also a chip toggles that chip; the rest live in A.avoids */
    var grp = null;
    AVOID_CHIPS.forEach(function(g){ if(g.items.indexOf(name) > -1) grp = g.key; });
    if(grp){
      var arr = A.avoidSel[grp], i = arr.indexOf(name);
      if(i > -1) arr.splice(i,1); else arr.push(name);
    } else {
      var j = A.avoids.indexOf(name);
      if(j > -1) A.avoids.splice(j,1); else A.avoids.push(name);
    }
    drawAvoids(); refresh();
  }
  function limitNote(){
    var n = $('#lqAvoidLimit');
    if(!n){
      var tags = $('#lqAvoidTags');
      if(!tags) return null;
      n = document.createElement('p');
      n.id = 'lqAvoidLimit';
      n.className = 'lq-note';
      n.style.fontWeight = '700';
      n.style.marginTop = '12px';
      tags.parentNode.insertBefore(n, tags.nextSibling);
    }
    return n;
  }
  function updateAvoidLimits(){
    var n = avoidCount();
    var extra = avoidExtra();
    var each = avoidFeeEach();
    var note = limitNote();
    if(!note) return;
    note.style.display = '';
    if(extra > 0){
      note.style.color = 'var(--clay)';
      note.textContent = extra === 1 ? txt('c_extra_one', { fee: extra * each, each: each }) : txt('c_extra_many', { fee: extra * each, n: extra, each: each });
    } else if(n === AVOID_FREE){
      note.style.color = 'var(--mute)';
      note.textContent = txt('c_used');
    } else {
      note.style.color = 'var(--mute)';
      note.textContent = txt('c_left', { n: AVOID_FREE - n });
    }
  }
  function drawAvoids(){
    var tags = $('#lqAvoidTags');
    if(tags){
      tags.innerHTML = '';
      A.avoids.forEach(function(v){
        var t = document.createElement('span'); t.className = 'lq-tagc';
        t.appendChild(document.createTextNode(v + ' '));
        var x = document.createElement('button');
        x.type = 'button'; x.setAttribute('aria-label', 'Remove ' + v); x.innerHTML = '&times;';
        x.addEventListener('click', function(){ removeAvoid(v); });
        t.appendChild(x);
        tags.appendChild(t);
      });
    }
    $$('#lqAvoidChips .lq-check').forEach(function(b){
      var key = b.getAttribute('data-k'), item = b.getAttribute('data-v');
      var on;
      if(AVOID_TRIGGER[item] === 'family') on = familyPicked(item).length > 0;
      else if(AVOID_TRIGGER[item]) on = !!(P && P.x === item && !P.removed);
      else on = A.avoidSel[key].indexOf(item) > -1;
      b.classList.toggle('on', on);
    });
    if(impossibleSet() && !(P && P.type === 'impossible')) P = { type:'impossible', closed:false, scroll:true };
    else if(!impossibleSet() && P && P.type === 'impossible') P = null;
    updateAvoidLimits();
    renderPanel();
  }

  /* ---------- THE AVOIDS PANEL (27 Aug 2026) - see the block comment above ---------- */
  function isVegStyle(){ return A.style === 'Vegetarian' || A.style === 'Vegan'; }
  function impossibleSet(){
    if(!isVegStyle()) return false;
    var legOut = PROTEIN_LEGUMES.every(hasAvoid);
    var eggsOut = A.style === 'Vegan' || A.avoidSel.allergens.indexOf('Egg') > -1;
    return legOut && eggsOut;
  }
  function openPanel(item){
    P = { type: AVOID_TRIGGER[item], x: item, closed:false, scroll:true };
    drawAvoids(); refresh();
  }
  function setStyle(style){
    A.style = style; A.planOverride = null;
    $$('.lq-opts[data-a="style"] button').forEach(function(b){ b.classList.toggle('on', b.getAttribute('data-v') === style); });
    buildProteins();
  }
  function planKeyIfStyle(style){
    var keepStyle = A.style, keepOv = A.planOverride;
    A.style = style; A.planOverride = null;
    var k = planKey();
    A.style = keepStyle; A.planOverride = keepOv;
    return k;
  }
  function planCost(k){
    var long = price().long, p = PLANS[k];
    return { price: long ? p.l : p.s, days: long ? (p.ldays || 26) : (p.sdays || 13) };
  }
  function offerHTML(k, styleName, line, act, v){
    var from = planKey(), a = planCost(k), b = planCost(from), diff = a.price - b.price;
    var vars = { price: whole(a.price), days: a.days, diff: whole(Math.abs(diff)), from: PLANS[from].name };
    var pk = k === 'fodmap' ? 'a_price_' : 'price_';
    var pl = txt(pk + (diff === 0 ? 'same' : (diff > 0 ? 'more' : 'less')), vars);
    var label = k === 'fodmap' ? txt('switch_to', { plan: 'Low-FODMAP' }) : txt('switch_to', { plan: styleName });
    return '<div class="lq-ap-offer"><div class="lq-ap-offer-t"><b>' + esc(styleName) + '</b><span>' + esc(line) + '</span><small>' + esc(pl) + '</small></div>' +
      '<button type="button" class="lq-ap-btn" data-act="' + act + '" data-v="' + esc(v) + '">' + esc(label) + '</button></div>';
  }
  function panelHead(eb, whyKey){
    return '<div class="lq-ap-head"><span class="lq-ap-eyebrow"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 19c0-8 5-13 14-14 0 9-5 14-13 14"/><path d="M5 19c3-4 6-7 10-9"/></svg>' + esc(txt(eb)) + '</span>' +
      '<button type="button" class="lq-ap-link" data-act="why">' + esc(txt('why')) + '</button></div>' +
      '<p class="lq-ap-why' + (P.why ? ' open' : '') + '">' + esc(txt(whyKey)) + '</p>';
  }
  function proteinPanel(){
    var x = P.x, xl = x.toLowerCase();
    if(isVegStyle() || A.style === 'Seafood & Vegetarian'){
      return panelHead('eb_plan','p_why') + '<p class="lq-ap-lead">' + esc(txt('p_already', { style: A.style, x: xl })) + '</p>' +
        '<div class="lq-ap-actions"><button type="button" class="lq-ap-btn ghost" data-act="premove">' + esc(txt('f_done')) + '</button></div>';
    }
    /* the plan a style switch would actually land on - a GLP-1, Keto or Gut Health
       customer keeps their plan whatever the style, so those offers are not shown */
    var cur = planKey(), kSv = planKeyIfStyle('Seafood & Vegetarian'), kVeg = planKeyIfStyle('Vegetarian');
    var goalDriven = { glp1:1, keto:1, fodmap:1 };
    var sv = !goalDriven[kSv] ? offerHTML(kSv, 'Seafood & Vegetarian', txt('opt_sv'), 'pswitch', 'Seafood & Vegetarian') : '';
    var veg = !goalDriven[kVeg] ? offerHTML(kVeg, 'Vegetarian', txt('opt_veg'), 'pswitch', 'Vegetarian') : '';
    if(!sv && !veg){
      return panelHead('eb_plan','p_why') + '<p class="lq-ap-lead">' + esc(txt('p_fixed', { plan: PLANS[cur].name, x: xl })) + '</p>' +
        '<div class="lq-ap-actions"><button type="button" class="lq-ap-btn ghost" data-act="premove">' + esc(txt('f_done')) + '</button></div>';
    }
    return panelHead('eb_plan','p_why') + '<p class="lq-ap-lead">' + esc(txt(x === 'Chicken' ? 'p_lead_chicken' : 'p_lead_red', { plan: PLANS[cur].name })) + '</p>' +
      '<div class="lq-ap-offers">' + (A.style === 'Meat & Seafood' ? sv + veg : veg + sv) + '</div>' +
      '<div class="lq-ap-actions under"><button type="button" class="lq-ap-link" data-act="premove">' + esc(txt('keep', { x: xl })) + '</button></div>';
  }
  function alliumPanel(){
    var x = P.x, xl = x.toLowerCase();
    if(planKey() === 'fodmap'){
      return panelHead('eb_plan','a_why') + '<p class="lq-ap-lead">' + esc(txt('p_already', { style: 'Low-FODMAP', x: xl })) + '</p>' +
        '<div class="lq-ap-actions"><button type="button" class="lq-ap-btn ghost" data-act="aremove">' + esc(txt('f_done')) + '</button></div>';
    }
    if(isVegStyle()){
      return panelHead('eb_plan','a_why') + '<p class="lq-ap-lead">' + esc(txt('a_veg', { x: xl })) + '</p>' +
        '<div class="lq-ap-actions"><button type="button" class="lq-ap-btn ghost" data-act="alight">' + esc(txt('f_done')) + '</button></div>';
    }
    return panelHead('eb_plan','a_why') + '<p class="lq-ap-lead">' + esc(txt('a_lead', { x: x })) + '</p>' +
      '<div class="lq-ap-offers">' + offerHTML('fodmap', 'Low-FODMAP', txt('a_opt'), 'aswitch', '') + '</div>' +
      '<div class="lq-ap-actions under"><button type="button" class="lq-ap-link" data-act="aremove">' + esc(txt('keep', { x: xl })) + '</button></div>';
  }
  function familyPanel(){
    var f = P.x, out = panelHead('eb_fam','f_why') + '<p class="lq-ap-lead">' + esc(txt(f === 'Nightshades' ? 'f_lead_night' : 'f_lead_leg')) + '</p><div class="lq-ap-members">';
    AVOID_FAMILY[f].forEach(function(m){
      out += '<button type="button" class="lq-check' + (hasAvoid(m[0]) ? ' on' : '') + '" data-m="' + esc(m[0]) + '"><i></i><span>' + esc(m[0]) + (m[1] ? ' <small>· ' + esc(m[1]) + '</small>' : '') + '</span></button>';
    });
    var n = familyPicked(f).length;
    return out + '</div><p class="lq-ap-hidden">' + esc(txt(f === 'Nightshades' ? 'f_hidden_night' : 'f_hidden_leg')) + '</p>' +
      '<div class="lq-ap-famfoot"><button type="button" class="lq-ap-btn ghost" data-act="fall">' + esc(txt('f_all')) + '</button><button type="button" class="lq-ap-link" data-act="fnone">' + esc(txt('f_none')) + '</button><span class="lq-ap-count">' + esc(n === 1 ? txt('f_count_one') : txt('f_count_many', { n: n })) + '</span></div>' +
      '<div class="lq-ap-actions" style="margin-top:14px"><button type="button" class="lq-ap-btn" data-act="fdone">' + esc(txt('f_done')) + '</button></div>';
  }
  function impossiblePanel(){
    var out = panelHead('eb_imp','i_why') + '<p class="lq-ap-lead">' + esc(txt('i_lead')) + '</p><div class="lq-ap-pills">';
    if(A.style === 'Vegetarian') out += '<button type="button" class="lq-ap-pill" data-act="ikeep" data-v="eggs">' + esc(txt('i_eggs')) + '</button>';
    out += '<button type="button" class="lq-ap-pill" data-act="ikeep" data-v="soy">' + esc(txt('i_soy')) + '</button>' +
      '<button type="button" class="lq-ap-pill" data-act="ikeep" data-v="beans">' + esc(txt('i_beans')) + '</button>' +
      '<button type="button" class="lq-ap-pill" data-act="ikeep" data-v="fish">' + esc(txt('i_fish')) + '</button></div>';
    return out;
  }
  function closePanel(summaryHTML, plain, removed){
    P.closed = true; P.removed = !!removed; P.summary = summaryHTML; P.plain = plain;
  }
  function panelAct(act, v){
    var x = P.x, xl = (x || '').toLowerCase();
    if(act === 'why'){ P.why = !P.why; renderPanel(); return; }
    if(act === 'pswitch'){ P.fromStyle = A.style; setStyle(v); var landed = PLANS[planKey()].name; var pn = (v === 'Vegetarian' && landed === 'Vegetarian') ? v : (v + ' · ' + landed); closePanel('<b>' + esc(txt('p_closed', { x: xl, plan: pn })) + '</b>', txt('p_closed', { x: xl, plan: pn })); drawAvoids(); refresh(); return; }
    if(act === 'premove'){ var t1 = (isVegStyle() || A.style === 'Seafood & Vegetarian') ? txt('p_already', { style: A.style, x: xl }) : txt('keep', { x: xl }); closePanel(esc(t1), t1, true); drawAvoids(); refresh(); return; }
    if(act === 'aswitch'){ A.planOverride = 'Low-FODMAP'; closePanel('<b>' + esc(txt('a_closed', { x: xl })) + '</b>', txt('a_closed', { x: xl })); drawAvoids(); refresh(); return; }
    if(act === 'alight'){ closePanel(esc(txt('a_closed_light', { x: xl })), txt('a_closed_light', { x: xl }), true); drawAvoids(); refresh(); return; }
    if(act === 'aremove'){ closePanel(esc(txt('keep', { x: xl })), txt('keep', { x: xl }), true); drawAvoids(); refresh(); return; }
    if(act === 'fall'){ AVOID_FAMILY[x].forEach(function(m){ if(!hasAvoid(m[0])) toggleMember(m[0]); }); return; }
    if(act === 'fnone'){ AVOID_FAMILY[x].forEach(function(m){ if(hasAvoid(m[0])) toggleMember(m[0]); }); return; }
    if(act === 'fdone'){
      var picked = familyPicked(x);
      if(!picked.length){ P = null; drawAvoids(); refresh(); return; }
      var t2 = txt('f_closed', { family: x, n: picked.length, list: picked.join(', ') });
      closePanel(esc(t2), t2); drawAvoids(); refresh(); return;
    }
    if(act === 'ikeep'){
      if(v === 'eggs'){ var ai = A.avoidSel.allergens.indexOf('Egg'); if(ai > -1) A.avoidSel.allergens.splice(ai,1); }
      if(v === 'soy'){ var si = A.avoidSel.allergens.indexOf('Soy'); if(si > -1) A.avoidSel.allergens.splice(si,1); }
      if(v === 'beans'){ ['Chickpea','Lentil'].forEach(function(m){ var j = A.avoids.indexOf(m); if(j > -1) A.avoids.splice(j,1); }); }
      if(v === 'fish'){ P.fromStyle = A.style; setStyle('Seafood & Vegetarian'); }
      var rk = { eggs:'i_eggs_r', soy:'i_soy_r', beans:'i_beans_r', fish:'i_fish_r' }[v];
      var t3 = txt(rk);
      P.type = 'impossible-done';
      closePanel(esc(t3), t3); drawAvoids(); refresh(); return;
    }
    if(act === 'change'){
      if(P.removed || P.type === 'impossible-done'){ P = null; drawAvoids(); refresh(); return; }
      if(P.type === 'protein' && P.fromStyle && A.style !== P.fromStyle){ setStyle(P.fromStyle); }
      if(P.type === 'allium' && A.planOverride === 'Low-FODMAP'){ A.planOverride = null; }
      P.closed = false; P.scroll = true; drawAvoids(); refresh(); return;
    }
  }
  function renderPanel(){
    var host = $('#lqPanel');
    if(!host) return;
    if(!P){ host.hidden = true; host.innerHTML = ''; return; }
    host.hidden = false;
    if(P.closed){
      host.innerHTML = '<div class="lq-ap closed"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l4 4 10-10"/></svg><span class="txt">' + P.summary + '</span><button type="button" class="lq-ap-link" data-act="change">' + esc(txt('change')) + '</button></div>';
    } else {
      var body = P.type === 'protein' ? proteinPanel() : (P.type === 'allium' ? alliumPanel() : (P.type === 'family' ? familyPanel() : impossiblePanel()));
      host.innerHTML = '<div class="lq-ap">' + body + '</div>';
    }
    $$('[data-act]', host).forEach(function(b){ b.addEventListener('click', function(){ panelAct(b.getAttribute('data-act'), b.getAttribute('data-v')); }); });
    $$('.lq-ap-members .lq-check', host).forEach(function(b){ b.addEventListener('click', function(){ toggleMember(b.getAttribute('data-m')); }); });
    if(P.scroll){
      P.scroll = false;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      try{ host.scrollIntoView({ block:'center', behavior: reduce ? 'auto' : 'smooth' }); }catch(e){}
    }
  }
  function buildAvoids(){
    var host = $('#lqAvoidChips');
    if(!host) return;
    host.innerHTML = '';
    AVOID_CHIPS.forEach(function(grp){
      var h = document.createElement('p'); h.className = 'lq-h5'; h.textContent = grp.head;
      host.appendChild(h);
      var grid = document.createElement('div'); grid.className = 'lq-checks';
      grp.items.forEach(function(item){
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'lq-check';
        b.setAttribute('data-k', grp.key);
        b.setAttribute('data-v', item);
        b.innerHTML = '<i></i><span>' + item + '</span>';
        b.addEventListener('click', function(){ toggleChip(grp.key, item); });
        grid.appendChild(b);
      });
      host.appendChild(grid);
    });
    drawAvoids();
  }
  function wireAvoids(){
    var inp = $('#lqAvoidIn');
    if(!inp) return;
    function commit(){ var v = inp.value; inp.value = ''; addAvoid(v); }
    inp.addEventListener('keydown', function(e){
      if(e.key === 'Enter' || e.key === ','){ e.preventDefault(); commit(); }
    });
    inp.addEventListener('blur', commit);
  }

  /* ---------- biomarkers ---------- */
  function buildBio(){
    var host = $('#lqBio');
    BIO.forEach(function(grp){
      var box = document.createElement('div'); box.className = 'lq-bio';
      box.innerHTML = '<h4>'+grp[0]+'</h4>';
      grp[1].forEach(function(mk){
        var row = document.createElement('div'); row.className = 'lq-mk';
        row.innerHTML = '<p>'+mk+'</p><div class="lq-hl"><button type="button" data-l="High">&#8593; High</button><button type="button" data-l="Low">&#8595; Low</button></div>';
        $$('button',row).forEach(function(b){
          b.addEventListener('click', function(){
            var l = b.getAttribute('data-l');
            if(A.flags[mk] === l){ delete A.flags[mk]; b.classList.remove('on'); }
            else { A.flags[mk] = l; $$('button',row).forEach(function(x){ x.classList.remove('on'); }); b.classList.add('on'); }
            refresh();
          });
        });
        box.appendChild(row);
      });
      host.appendChild(box);
    });
  }

  /* ---------- matching ---------- */
  function flagged(list){ return Object.keys(A.flags).some(function(k){ return list.indexOf(k) > -1; }); }
  function match(){
    var g = A.goal || '', r = [], key;
    if(A.glp1 === 'Yes'){ key='glp1'; r.push('You are on a GLP-1 medication — every meal is built to protect muscle and beat nausea and constipation.'); }
    else if(A.style === 'Vegan'){ key='vegan'; r.push('You eat fully plant-based — this is our cleanest plant programme.'); }
    else if(A.style === 'Vegetarian'){ key='vegetarian'; r.push('You eat vegetarian — plants plus eggs and ghee where a dish calls for them.'); }
    else if(g === 'Gut Health'){ key='fodmap'; r.push('Gut health is your goal — Low-FODMAP removes the trigger carbs behind bloating.'); }
    else if(g === 'Blood Sugar Control' || flagged(['Fasting Glucose','HbA1c (A1c)','Insulin','HOMA-IR'])){ key='keto'; r.push('Your blood-sugar picture points to a low-carb reset — clean keto, no sweeteners and no shortcuts. It is a reset, not a way to eat forever.'); }
    else if(A.style === 'Seafood & Vegetarian'){ key='meatseafood'; r.push('You would rather skip land meat — start here and say so in your foods to avoid. We will build your days around fish and vegetarian dishes.'); }
    else if(A.style === 'Meat & Seafood'){ key='meatseafood'; r.push('You eat meat and seafood — the Signature day with fish, prawns and crab on the menu.'); }
    else { key='signature'; r.push('The complete LUVF day — three meals, a salad and a snack, balanced around your goal: '+(g||'feeling your best')+'.'); }
    if(flagged(['Total Cholesterol','LDL ("bad" cholesterol)','Triglycerides','ApoB','CRP / hs-CRP','Homocysteine'])) r.push('Flagged heart or inflammation markers — we cook with olive, avocado and coconut oil and ghee only, never seed oils.');
    if(flagged(['Vitamin D','Vitamin B12','Folate','Iron','Ferritin','Omega-3','Magnesium'])) r.push('Low vitamins or minerals get targeted through the menu — dishes rich in what you are missing.');
    if(A.dairy === 'No dairy') r.push('No dairy at all — we leave the ghee out too, and we will not send you our dairy products.');
    if(A.avoidSel.allergens.length) r.push('Allergies noted (' + A.avoidSel.allergens.join(', ') + ') — flagged as a safety stop, not a preference. Those dishes never leave the kitchen for you.');
    var soft = A.avoidSel.prefs.concat(A.avoids);
    if(soft.length) r.push('Also leaving out ' + soft.join(', ') + ' — we swap the ingredient, you still get the meal.');
    return { key:key, reasons:r };
  }
  function portion(){
    var s = 0;
    if(A.activity === 'Active' || A.activity === 'Athlete') s++;
    if(A.goal === 'Build Muscle') s++;
    if((A.drivers||[]).indexOf('I train hard and need food that keeps up') > -1) s++;
    if(A.goal === 'Lose Weight') s--;
    return s > 0 ? 'Extra portions' : (s < 0 ? 'Portion-controlled' : 'Standard portions');
  }
  function planKey(){
    if(A.planOverride){ for(var k in PLANS){ if(PLANS[k].name === A.planOverride) return k; } }
    return match().key;
  }
  function recommendedSize(){ return portion() === 'Extra portions' ? 'Large' : 'Standard'; }
  function chosenSize(){ return A.sizeOverride || recommendedSize(); }
  function price(){
    var p = PLANS[planKey()];
    var hasShort = !!p.s;
    var long = !hasShort || (A.length || '26') === '26';
    var large = chosenSize() === 'Large';
    var total = long ? (large ? p.lL : p.l) : (large ? p.sL : p.s);
    var days = long ? (p.ldays || 26) : (p.sdays || 13);
    var items = p.items || 5;
    var shortEach = large ? p.sL : p.s;
    return {
      total: total, days: days, long: long, large: large, items: items,
      hasShort: hasShort,
      perDay: total / days,
      perItem: total / days / items,
      save: (hasShort && long) ? (shortEach * 2) - total : 0,
      twoShort: hasShort ? shortEach * 2 : 0
    };
  }
  function weekText(){
    var p = PLANS[planKey()];
    if(p.dw) return p.dw;
    return (A.days === '6') ? '6 days - Fridays off' : '7 days';
  }

  /* ---------- render program + review ---------- */
  function priceLine(pr){
    return whole(pr.total) + ' KD <small>for ' + pr.days + ' days &middot; ' + d1(pr.perDay) + ' KD a day &middot; about ' + d1(pr.perItem) + ' KD an item</small>';
  }
  function ensureNote(id, afterEl){
    var n = $('#' + id);
    if(!n && afterEl){
      n = document.createElement('p');
      n.id = id;
      n.className = 'lq-note';
      n.style.margin = '8px 0 0';
      afterEl.parentNode.insertBefore(n, afterEl.nextSibling);
    }
    return n;
  }
  function renderLength(){
    var p = PLANS[planKey()];
    var wrap = $('#lqLength');
    if(!wrap) return;
    var b13 = wrap.querySelector('button[data-v="13"]');
    var b26 = wrap.querySelector('button[data-v="26"]');
    var note = ensureNote('lqLengthOnly', wrap);
    if(b26){
      var lb = b26.querySelector('b');
      if(lb) lb.textContent = (p.ldays || 26) + ' days';
      var lsub = b26.querySelector('span:not(.lq-badge)');
      if(lsub) lsub.textContent = p.lsub || 'Cheaper every day';
      var badge = b26.querySelector('.lq-badge');
      if(badge) badge.style.display = p.s ? '' : 'none';
    }
    if(!p.s){
      if(b13){ b13.style.display = 'none'; b13.classList.remove('on'); }
      if(b26){ b26.classList.add('on'); }
      A.length = '26';
      if(note){ note.textContent = p.name + ' comes in one length only — ' + (p.ldays || 26) + ' days.'; note.hidden = false; }
    } else {
      if(b13){
        b13.style.display = '';
        var sb = b13.querySelector('b'); if(sb) sb.textContent = (p.sdays || 13) + ' days';
        var ssub = b13.querySelector('span:not(.lq-badge)'); if(ssub) ssub.textContent = 'Half the days, more per day';
      }
      if(note) note.hidden = true;
      var onL = wrap.querySelector('button.on');
      if(onL) A.length = onL.getAttribute('data-v');
    }
  }
  function renderWeek(){
    var p = PLANS[planKey()];
    var wrap = $('.lq-opts[data-a="days"]');
    if(!wrap) return;
    var btns = $$('button', wrap);
    var note = ensureNote('lqWeekOnly', wrap);
    if(p.dw){
      btns.forEach(function(b){ b.style.display = 'none'; b.classList.remove('on'); });
      A.days = p.dwVal;
      if(note){ note.textContent = p.name + ' is delivered ' + p.dw + '. It is not a choice on this plan.'; note.hidden = false; }
    } else {
      btns.forEach(function(b){ b.style.display = ''; });
      var on = null;
      btns.forEach(function(b){ if(b.classList.contains('on')) on = b; });
      A.days = on ? on.getAttribute('data-v') : '';
      if(note) note.hidden = true;
    }
  }

  function renderProgram(){
    var m = match(), p = PLANS[planKey()], pr = price();
    var fee = avoidFee(), fx = avoidExtra();
    $('#lqReco').innerHTML =
      '<span class="lq-tag">Recommended for you</span>' +
      '<h3>'+p.name+'</h3>' +
      '<p style="font-size:14px;margin:0;line-height:1.5">'+p.desc+'</p>' +
      '<ul class="lq-why">'+ m.reasons.map(function(x){ return '<li>'+x+'</li>'; }).join('') +'</ul>' +
      (p.cal ? '<p style="font-size:12px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:var(--mute);margin:14px 0 2px">Calories</p><p style="font-family:Poppins,sans-serif;font-weight:600;font-size:16px;color:var(--ink);margin:0">'+((pr.large && p.calL) ? p.calL : p.cal)+'</p>' : '') +
      '<p class="lq-price" style="margin:16px 0 0">'+priceLine(pr)+'</p>' +
      (fx ? '<p style="color:var(--clay);font-weight:700;font-size:14px;margin:6px 0 0">+ '+fee+' KD &middot; '+fx+' extra food'+(fx>1?'s':'')+' to avoid ('+avoidFeeEach()+' KD each) — total '+whole(pr.total+fee)+' KD</p>' : '') +
      '<p class="lq-portion">Your portions: '+portion()+(pr.large ? ' · Large size' : '')+'</p>';
    var other = $('#lqOther');
    other.innerHTML = '';
    var isLong = (A.length || '26') === '26';
    var wantLarge = pr.large;
    Object.keys(PLANS).forEach(function(k){
      if(k === m.key && !A.planOverride) return;
      if(A.planOverride && PLANS[k].name === A.planOverride) return;
      var o = PLANS[k];
      var oLong = isLong || !o.s;
      var oPrice = oLong ? (wantLarge ? o.lL : o.l) : (wantLarge ? o.sL : o.s);
      var b = document.createElement('button');
      b.className='lq-opt'; b.type='button'; b.setAttribute('data-v', o.name);
      b.innerHTML = '<b>'+o.name+' &middot; '+whole(oPrice)+' KD</b><span>'+o.desc+'</span>';
      b.addEventListener('click', function(){
        A.planOverride = o.name;
        refresh(); renderProgram();
      });
      other.appendChild(b);
    });
    renderSize();
    renderLength();
    renderWeek();
    renderSaveLine($('#lqSaveLine'), price());
  }
  function renderSize(){
    var host = $('#lqSize'); host.innerHTML = '';
    var rec = recommendedSize();
    var p = PLANS[planKey()];
    var long = !p.s || (A.length || '26') === '26';
    var stdPrice = long ? p.l : p.s;
    var lgePrice = long ? p.lL : p.sL;
    var extra = (lgePrice && stdPrice) ? lgePrice - stdPrice : 0;
    var lgeSub = 'Extra portions — training days, bigger appetites';
    if(extra > 0) lgeSub += ' · +' + extra + ' KD';
    [['Standard', portion() === 'Portion-controlled' ? 'Portion-controlled for your goal' : 'Balanced portions for most days'],
     ['Large', lgeSub]].forEach(function(sz){
      var b = document.createElement('button');
      b.className = 'lq-opt' + (chosenSize() === sz[0] ? ' on' : ''); b.type='button';
      b.innerHTML = '<b>'+sz[0]+'</b><span>'+sz[1]+'</span>' + (rec === sz[0] ? '<span class="lq-badge">Recommended</span>' : '');
      b.addEventListener('click', function(){ A.sizeOverride = sz[0]; renderProgram(); refresh(); });
      host.appendChild(b);
    });
  }
  function renderSaveLine(save, pr){
    if(!save) return;
    if(pr.hasShort && pr.long && pr.save > 0){
      save.hidden = false;
      save.textContent = 'Two ' + (PLANS[planKey()].sdays || 13) + '-day plans would cost ' + whole(pr.twoShort) + ' KD. This is ' + whole(pr.total) + ' — you save ' + whole(pr.save) + ' KD.';
    } else { save.hidden = true; }
  }

  function renderReview(){
    var p = PLANS[planKey()], pr = price();
    var startTxt = A.start ? new Date(A.start + 'T00:00:00').toDateString() : '—';
    var extraAvoids = avoidExtra();
    var fee = avoidFee();
    var soft = A.avoidSel.prefs.concat(A.avoids);
    var dairyTxt = A.dairy === 'No dairy'
      ? 'no dairy at all, ghee included'
      : 'no A1 dairy — happy to receive our dairy products';
    $('#lqReview').innerHTML =
      '<div class="lq-sum"><h4>Programme</h4>' +
        '<p><b>'+p.name+'</b> · '+chosenSize()+' size · '+portion()+'</p>' +
        '<p>'+pr.items+' items a day · '+pr.days+' days · delivered '+weekText()+'</p>' +
        '<p>Starts '+startTxt+'</p></div>' +
      '<div class="lq-sum"><h4>Your food rules</h4>' +
        '<p>'+(A.style||'—')+' · '+dairyTxt+'</p>' +
        (A.proteins.length ? '<p>Favourite proteins: '+A.proteins.join(', ')+'</p>' : '') +
        (A.cuisines.length ? '<p>Favourite cuisines: '+A.cuisines.join(', ')+'</p>' : '') +
        (A.avoidSel.allergens.length ? '<p><b>Allergies — never served:</b> '+A.avoidSel.allergens.join(', ')+'</p>' : '') +
        (soft.length ? '<p>Leave out: '+soft.join(', ')+'</p>' : '') +
        (extraAvoids ? '<p style="color:var(--clay)"><b>+'+fee+' KD — '+extraAvoids+' extra food'+(extraAvoids>1?'s':'')+' to avoid beyond the three included ('+avoidFeeEach()+' KD each), added to your total below.</b> We would always rather know about an allergy than not — the kitchen confirms every allergy with you before anything is prepared.</p>' : '') +
        '<p>Always: gluten-free · no A1 dairy · unrefined sweeteners only · clean oils only</p>' +
        (Object.keys(A.flags).length ? '<p>Lab flags: '+Object.keys(A.flags).map(function(x){ return x+' '+A.flags[x].toLowerCase(); }).join(', ')+'</p>' : '') + '</div>' +
      '<div class="lq-sum"><div class="lq-total">' +
        '<h4 style="font-size:16px">Total</h4>' +
        '<div style="text-align:right"><p class="lq-price">'+whole(pr.total + fee)+' KD</p>' +
        '<p style="margin:2px 0 0"><small style="color:var(--mute);font-size:12px">'+chosenSize()+' · '+pr.days+' days'+(extraAvoids ? ' · incl. '+fee+' KD extra avoids' : '')+' · '+d1(pr.perDay)+' KD a day · about '+d1(pr.perItem)+' KD an item</small></p></div>' +
      '</div></div>';
  }

  /* ---------- rail ---------- */
  function buildRail(){
    rail.innerHTML = '';
    steps.forEach(function(s, i){
      var label = s.getAttribute('data-rail');
      if(!label) return;
      var d = document.createElement('div'); d.className = 'lq-r'; d.setAttribute('data-i', i);
      d.innerHTML = '<div class="lq-rt">'+label+'</div><div class="lq-ra"></div>';
      rail.appendChild(d);
    });
  }
  function railText(i){
    switch(i){
      case 1: return [A.name, A.area, A.governorate, A.phone].filter(Boolean).join('\n');
      case 2: return A.goal || '';
      case 3: return [A.gender, A.age, A.activity ? 'Activity · '+A.activity : '', A.glp1 ? (A.glp1==='Yes'?'On GLP-1':'No GLP-1') : ''].concat(A.drivers||[]).filter(Boolean).join(', ');
      case 4: var av = allAvoids(); return [A.style, av.length ? 'Avoiding: '+av.join(', ') : '', A.cuisines.length ? A.cuisines.join(', ') : ''].filter(Boolean).join(' · ');
      case 5: if(A.labGate === 'Skip for now') return 'Skipped'; var n = Object.keys(A.flags).length; return n ? n + ' marker' + (n>1?'s':'') + ' flagged' : '';
      case 6: var k = planKey(); return (A.length||A.days||A.sizeOverride) ? PLANS[k].name + ' · ' + chosenSize() + ' · ' + price().days + ' days' : '';
      default: return '';
    }
  }
  function refresh(){
    $$('.lq-r', rail).forEach(function(d){
      var i = parseInt(d.getAttribute('data-i'),10);
      d.classList.toggle('on', i === cur);
      d.classList.toggle('done', i < cur);
      $('.lq-ra', d).textContent = i <= cur ? railText(i) : '';
    });
    var nxb = $('#lqNext');
    nxb.disabled = !valid();
    if(cur === 4) nxb.textContent = (P && !P.closed) ? txt('hold') : 'Continue';
  }
  function valid(){
    switch(cur){
      case 1: return !!(A.name && A.governorate);
      case 2: return !!A.goal;
      case 3: return !!(A.gender && A.age && A.activity && A.glp1);
      case 4: return !!(A.style && A.dairy) && !(P && !P.closed);
      case 5: return !!A.labGate;
      case 6: return !!(A.days && A.length && A.start);
      case 7: return A.ack;
      default: return true;
    }
  }

  /* ---------- nav + step chrome ---------- */
  function go(i){
    cur = Math.max(0, Math.min(steps.length - 1, i));
    steps.forEach(function(s, j){ s.classList.toggle('on', j === cur); });
    var s = steps[cur], lab = s.getAttribute('data-lab');
    $('#lqTopBack').hidden = cur === 0;
    $('#lqStepLab').hidden = !lab;
    if(lab){
      $('#lqStepTxt').textContent = lab;
      $('#lqStepPct').textContent = s.getAttribute('data-pct') + '%';
      $('#lqStepBar').style.width = s.getAttribute('data-pct') + '%';
    }
    $('#lqBack').hidden = cur === 0;
    $('#lqBar').style.width = Math.round(cur / (steps.length - 1) * 100) + '%';
    var nx = $('#lqNext');
    nx.textContent = cur === 0 ? 'Get started' : (cur === steps.length - 1 ? 'Start my plan' : 'Continue');
    if(cur === 2 && A.name) $('#lqGoalHead').textContent = 'What matters most, ' + A.name + '?';
    if(cur === 6) renderProgram();
    if(cur === 7) renderReview();
    window.scrollTo({ top: 0, behavior: 'smooth' });
    refresh();
  }

  /* ---------- homepage hand-off ---------- */
  function prefill(){
    var sp;
    try{ sp = new URLSearchParams(window.location.search); }catch(e){ return; }
    var ph = sp.get('plan');
    if(ph){
      for(var k in PLANS){
        if(PLANS[k].handle === ph){ A.planOverride = PLANS[k].name; break; }
      }
    }
    var ln = sp.get('len');
    if(ln === '13' || ln === '26'){
      A.length = ln;
      var lb = document.querySelector('#lqLength button[data-v="' + ln + '"]');
      if(lb){ $$('button', lb.parentNode).forEach(function(x){ x.classList.remove('on'); }); lb.classList.add('on'); }
    }
    var dy = sp.get('days');
    if(dy === '6' || dy === '7'){
      A.days = dy;
      var db = document.querySelector('.lq-opts[data-a="days"] button[data-v="' + dy + '"]');
      if(db){ $$('button', db.parentNode).forEach(function(x){ x.classList.remove('on'); }); db.classList.add('on'); }
    }
  }

  /* ---------- checkout ---------- */
  /* 'Size' is deliberately NOT in this list (20 Aug 2026, draft 20): the
     variant title already reads "26 Days / Standard", so showing the Size
     property too printed "Size Standard" twice on the cart and checkout.
     hideProps prefixes it to _Size — hidden from display, still on the
     order for the kitchen and Flow. */
  var SHOW_AT_CHECKOUT = { 'Programme':1, 'Duration':1, 'Days per week':1, 'Start date':1 };
  function hideProps(props){
    var out = {};
    Object.keys(props).forEach(function(k){
      if(!props[k]) return;
      out[SHOW_AT_CHECKOUT[k] ? k : '_' + k] = props[k];
    });
    return out;
  }
  /* PICK THE VARIANT BY WHAT THE CUSTOMER CHOSE, NEVER BY POSITION.
     This used to be variants[0] for short and variants[last] for long.
     On 20 Aug the plans gained a Size option, and variants[last] silently
     became "26 Days / Large" - every long plan would have been charged
     the Large price. Matching on option values cannot drift like that. */
  function pickVariant(prod, pr, size){
    var vs = prod.variants || [];
    var wantDur = pr.days + ' Days';
    var offersSize = false;
    vs.forEach(function(v){
      var o = v.options || [];
      if(o.indexOf('Standard') > -1 || o.indexOf('Large') > -1) offersSize = true;
    });
    var hit = null;
    vs.forEach(function(v){
      if(hit) return;
      var o = v.options || [];
      if(o.indexOf(wantDur) === -1) return;
      if(offersSize && o.indexOf(size) === -1) return;
      hit = v;
    });
    return hit || (pr.long ? vs[vs.length - 1] : vs[0]);
  }

  /* EXTRA AVOIDS ARE CHARGED THROUGH A SECOND CART LINE (20 Aug, late
     evening - Anas). Product handle 'extra-food-to-avoid', hidden from
     every shelf, two variants: '26-day plan' at 5 KD and '13-day plan'
     at 3 KD. Quantity = number of avoids beyond three. Prices live on
     the variants, never here - see the pricing comment at the top. */
  function addAvoidFee(){
    var fx = avoidExtra();
    if(!fx) return Promise.resolve();
    var wantV = price().long ? '26-day plan' : '13-day plan';
    return fetch('/products/' + AVOID_FEE_HANDLE + '.js').then(function(r){ return r.json(); }).then(function(sp){
      var sv = null;
      (sp.variants || []).forEach(function(v){ if(v.title === wantV) sv = v; });
      if(!sv) sv = (sp.variants || [])[0];
      if(!sv) return;
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: sv.id, quantity: fx, properties: { 'Why': 'Foods to avoid beyond the three included' } })
      }).then(function(r2){ if(!r2.ok) throw new Error('cart'); });
    });
  }

  function finish(){
    var nx = $('#lqNext'); nx.disabled = true; nx.textContent = 'Adding your plan…';
    var p = PLANS[planKey()], pr = price();
    fetch('/products/' + p.handle + '.js').then(function(r){ return r.json(); }).then(function(prod){
      var v = pickVariant(prod, pr, chosenSize());
      var props = {
        'Programme': p.name, 'Size': chosenSize(), 'Portions': portion(),
        'Duration': pr.days + ' days',
        'Days per week': weekText(),
        'Start date': A.start || '',
        'Items a day': String(pr.items),
        'Name': A.name || '', 'Governorate': A.governorate || '', 'Area': A.area || '', 'Mobile': A.phone || '',
        'Goal': A.goal || '', 'Drivers': (A.drivers||[]).join(', '),
        'Gender': A.gender || '', 'Age': A.age || '',
        'Activity': A.activity || '', 'GLP-1': A.glp1 || '',
        'Eating style': A.style || '', 'Dairy products': A.dairy === 'No dairy' ? 'No dairy at all, ghee included' : 'Happy to receive dairy products',
        'Favourite proteins': A.proteins.join(', '),
        'Cuisines': A.cuisines.join(', '),
        'Foods to avoid': allAvoids().join(', '),
        'Avoid allergens': A.avoidSel.allergens.join(', '),
        'Avoid preferences': A.avoidSel.prefs.concat(A.avoids).join(', '),
        /* 27 Aug 2026 - the free-typed words ALSO travel on their own. 'Avoid
           preferences' feeds the luvf.avoid_exclusions choice list, and one
           unknown word ("quinoa") makes Shopify reject the whole list write,
           wiping the customer's avoids. Flow should read the typed words from
           _Avoid typed into luvf.foods_to_avoid (free text). Family members
           are choice-list values now, so they stay in Avoid preferences. */
        'Avoid typed': A.avoids.filter(function(v){ return !familyOf(v); }).join(', '),
        'Lab flags': Object.keys(A.flags).map(function(x){ return x + ' ' + A.flags[x]; }).join(', '),
        'Panel': (P && P.closed && P.plain) ? P.plain : ''
      };
      if(avoidExtra() > 0) props['Extra avoids'] = avoidExtra() + ' beyond the three included - ' + avoidFeeEach() + ' KD each, charged on this order';
      if(A.height) props['Height'] = A.height + ' cm';
      if(A.weight) props['Weight'] = A.weight + ' kg';
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: v.id, quantity: 1, properties: hideProps(props) })
      });
    }).then(function(r){
      if(!r.ok) throw new Error('cart');
      return addAvoidFee();
    }).then(function(){
      var q = [];
      function ap(k, val){ if(val) q.push(k + '=' + encodeURIComponent(val)); }
      ap('checkout[shipping_address][first_name]', A.name);
      ap('checkout[shipping_address][city]', A.area);
      ap('checkout[shipping_address][province]', GOV_CODES[A.governorate] || '');
      ap('checkout[shipping_address][country]', 'Kuwait');
      ap('checkout[shipping_address][phone]', A.phone);
      window.location.href = '/checkout' + (q.length ? '?' + q.join('&') : '');
    }).catch(function(){
      nx.disabled = false; nx.textContent = 'Start my plan';
      alert('Something went wrong adding your plan — please try again.');
    });
  }

  /* ---------- boot ---------- */
  function init(){
    steps = $$('.lq-step'); rail = $('#lqRail');
    /* Earliest start on the KUWAIT clock: orders close at 21:00 Kuwait (the
       kitchen buys and prints for the next day before then), so after 21:00
       the earliest start is the day after tomorrow. Anas, 3 Sep 2026. The
       same rule sits in sections/luvf-meals-hero.liquid for the fast track. */
    var t = new Date(Date.now() + (new Date().getTimezoneOffset() + 180) * 60000);
    t.setDate(t.getDate() + (t.getHours() >= 21 ? 2 : 1));
    var pad = function(n){ return (n < 10 ? '0' : '') + n; };
    var iso = t.getFullYear() + '-' + pad(t.getMonth() + 1) + '-' + pad(t.getDate());
    var sd = $('#lqStart'); sd.min = iso; sd.value = iso; A.start = iso;
    loadPanelTxt();
    buildRail(); buildBio(); buildCuisines(); buildProteins(); buildAvoids(); wire(); wireAvoids();
    var ack = $('#lqAck');
    ack.addEventListener('click', function(){ A.ack = !A.ack; ack.classList.toggle('on', A.ack); $('#lqAckHint').hidden = A.ack; refresh(); });
    $('#lqBioBack').addEventListener('click', function(){
      $('#lqBioWrap').hidden = true; $('#lqGateView').hidden = false;
    });
    $('#lqNext').addEventListener('click', function(){ cur === steps.length - 1 ? finish() : go(cur + 1); });
    $('#lqBack').addEventListener('click', function(){ go(cur - 1); });
    $('#lqTopBack').addEventListener('click', function(){ go(cur - 1); });
    prefill();
    go(0);
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }

/* Lift quiz footer above Shopify preview bar (password-protected preview mode) */
function lqLiftFoot(){
  var pb = document.querySelector('iframe[id*="PBar"], #preview-bar-iframe');
  var f = document.querySelector('.lq-foot');
  if(f){ f.style.bottom = pb ? '64px' : '0px'; }
}
lqLiftFoot(); setTimeout(lqLiftFoot,800); setTimeout(lqLiftFoot,2500);
window.addEventListener('resize', lqLiftFoot);
})();